export const AUTHORITIES = {
  CATEGORY_ALL: "CATEGORY-ALL",
  COURSE_ALL: "COURSE-ALL",
  FEE_ALL: "FEE-ALL",
  ORGANIZATION_ALL: "ORGANIZATION-ALL",
  PERMISSION_ALL: "PERMISSION-ALL",
  RESOURCE_ALL: "RESOURCE-ALL",
  ROLE_ALL: "ROLE-ALL",
  SEMESTER_ALL: "SEMESTER-ALL",
  USER_ALL: "USER-ALL",
  BUILDING_ALL: "BUILDING-ALL",
  ROOM_ALL: "ROOM-ALL",
  PARENT_ALL: "PARENT-ALL",
  STUDENT_ALL: "STUDENT-ALL",
  PAYMENT_ALL: "PAYMENT-ALL"
}; 